import { BrowserInfo } from '../schema';

export const getBrowserInfo = (): BrowserInfo => {
  const nav = navigator;
  const screen = window.screen;
  const location = window.location;

  return {
    userAgent: nav.userAgent,
    platform: nav.platform,
    language: nav.language,
    cookieEnabled: nav.cookieEnabled,
    onLine: nav.onLine,
    screenResolution: `${screen.width}x${screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timestamp: new Date().toISOString(),
    url: location.href,
    referrer: document.referrer || 'Direct access',
  };
};

export const getBrowserSummary = (browserInfo: BrowserInfo): string => {
  const { userAgent, platform, language, screenResolution, viewportSize, timezone } = browserInfo;

  // Extract browser name and version from user agent
  let browser = 'Unknown';
  let version = 'Unknown';

  if (userAgent.includes('Chrome')) {
    browser = 'Chrome';
    const match = userAgent.match(/Chrome\/([0-9.]+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Firefox')) {
    browser = 'Firefox';
    const match = userAgent.match(/Firefox\/([0-9.]+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = 'Safari';
    const match = userAgent.match(/Version\/([0-9.]+)/);
    version = match ? match[1] : 'Unknown';
  } else if (userAgent.includes('Edge')) {
    browser = 'Edge';
    const match = userAgent.match(/Edg\/([0-9.]+)/);
    version = match ? match[1] : 'Unknown';
  }

  return `${browser} ${version} on ${platform} | ${language} | ${screenResolution} (${viewportSize}) | ${timezone}`;
};
